// "static" imports
//type __ = typeof import("js-vextensions/Helpers/@ApplyCETypes");
import "./Utils/PreRunners/Start_0.js";
//import "babel-polyfill";
import "webpack-runtime-require";
import "./Utils/ClassExtensions/CE_General.js";
import "./Utils/General/NPMRuntimePatches.js";
import "./Utils/PreRunners/Start_1.js";
import "codemirror";
import "codemirror/addon/scroll/simplescrollbars";
import "./Utils/UI/CodeMirrorConfig.js";
// needed to fix odd ts issue (where, if first "import" call for library is in wvc, all subsequent imports of it are assumed to be referencing that under-wvc version)
import "mobx-graphlink";

import ReactDOM from "react-dom";
// import Promise from "bluebird";
import {VURL} from "js-vextensions";

/*import "web-vcore";
import "js-vextensions/Helpers/@ApplyCECode.js";*/
//import "web-vcore/nm/js-vextensions_ApplyCETypes.js";
import "web-vcore/TSHelpers/js-vextensions_ApplyCETypes.js";
import {RootState} from "./Store/index.js";

// startup (non-hot)
// ==========

export const JustBeforeInitLibs_listeners = [] as (()=>any)[];
export function JustBeforeInitLibs(listener: ()=>any) { JustBeforeInitLibs_listeners.push(listener); }

export const JustBeforeUI_listeners = [] as (()=>any)[];
export function JustBeforeUI(listener: ()=>any) { JustBeforeUI_listeners.push(listener); }

declare const __webpack_require__;
g.webpackData = __webpack_require__;

const startURL = VURL.Parse(window.location.href);
declare global { export const startURL: VURL; } G({startURL});

let storeTemp = {} as RootState;
try {
	const storeTemp_json = localStorage.__mobx_sync__;
	if (storeTemp_json) {
		try { // defensive
			storeTemp = JSON.parse(storeTemp_json);
		} catch (ex) {}
	}
}
// if "localStorage" is blocked, and something went wrong with our polyfill of it above, show an error message to user
catch (ex) {
	prompt(
		"Lucid Frontier failed to load map-data from local-storage; site cannot function without local-storage enabled.\n\n"
		+ "If Lucid Frontier is loaded in an iframe, you can most likely solve this by disabling the \"Block third-party cookies\" option in Chrome's incognito-mode new-tab, then refreshing.\n\n"
		+ "For more info, you can copy and visit the link below.",
		"https://stackoverflow.com/a/69004255",
	);
}
function AsNotNull(val: any) {
	if (val == null || val == "null") return null;
	return val;
}

// these props get compile-time-replaced (for dead-code-elimination); we never actually add these onto `globalThis`, but we declare them here, so intellisense shows it as option
declare global { var ENV: string; var DEV: boolean; var PROD: boolean; var TEST: boolean; }
// these props do not get compile-time-replaced; these are intentionally able to be modified at runtime (eg. in dev-tools console, or with url flags), eg. to enable/disable certain profiling-data collection
declare global { var ENV_DYN: string; var ENV_DYN_ORIG: string; var DEV_DYN: boolean; var PROD_DYN: boolean; var TEST_DYN: boolean; }

// start by loading the "X_DYN" vars from the compile-time insertions
Object.assign(g, {ENV_DYN: ENV, ENV_DYN_ORIG: ENV, DEV_DYN: DEV, PROD_DYN: PROD, TEST_DYN: TEST});

// probably temp; mitigate drawback of using the "justDeploy.prod" script, by "resetting" the compile-time-insertions of "env=dev" when site is being loaded from prod domain
if (startURL.DomainWithoutProtocol == "lucidfrontier.com") {
	Object.assign(g, {ENV_DYN: "prod", ENV_DYN_ORIG: "prod", DEV_DYN: false, PROD_DYN: true, TEST_DYN: false});
}

// now, check the URL and store for potential user-overrides of the "X_DYN" derivative-vars (eg. the subset of env-references that opt-in to allowing runtime overrides)
const envStr = AsNotNull(startURL.GetQueryVar("env")) || storeTemp.main?.envOverride;
if (envStr) {
	console.log(`Using env: ${envStr}`);
	g.ENV_DYN = envStr;
	g.DEV_DYN = envStr == "dev";
	g.PROD_DYN = envStr == "prod";
	g.TEST_DYN = envStr == "test";
}

declare global { var DB: string; }

g.DB = g.ENV_DYN;
/*if (location.host == "localhost:4100" || location.host == "localhost:4101") {
	g.DB = "dev";
}*/
const dbStr = AsNotNull(startURL.GetQueryVar("db")) || storeTemp.main?.dbOverride;
if (dbStr) {
	console.log(`Using db: ${dbStr}`);
	g.DB = dbStr;
}

/*
//let {version} = require("../../../package.json");
// Note: Use two BakedConfig files, so that dev-server can continue running, with its own baked-config data, even while prod-deploy occurs.
// Note: Don't reference the BakedConfig files from anywhere but here (in runtime code) -- because we want to be able to override it, below.
//let {version, dbVersion, firebaseConfig} = DEV ? require("./BakedConfig_Dev") : require("./BakedConfig_Prod");
const {version, firebaseConfig} = DB == "development" ? require("./BakedConfig_Dev") : require("./BakedConfig_Prod");

let dbVersion = 6;
if (startURL.GetQueryVar("dbVersion") && startURL.GetQueryVar("dbVersion") != "null") {
	dbVersion = parseInt(startURL.GetQueryVar("dbVersion")!);
	console.log(`Using dbVersion: ${dbVersion}`);
}
export {version, dbVersion, firebaseConfig};
//G({version, dbVersion, firebaseConfig}); declare global { var version: string, dbVersion: number, firebaseConfig; }
*/

// hot-reloading
// ==========

/*let hotReloading = false;
G({hotReloading}); declare global { let hotReloading: boolean; }*/
export const hasHotReloaded = false;

// this code is excluded from production bundle
/*if (DEV) {
	/* if (window.devToolsExtension)
		window.devToolsExtension.open(); *#/
	if (module['hot']) {
		// setup hot module replacement
		module['hot'].accept('./Main_Hot', () => {
			hasHotReloaded = true;
			setTimeout(() => {
				ReactDOM.unmountComponentAtNode(document.getElementById('root'));
				LoadHotModules();
			});
		});
		module['hot'].accept('./Store', () => {
			const { MakeRootReducer } = require('./Store');
			store.reducer = MakeRootReducer();
			store.replaceReducer(store.reducer);
		});
	}
}*/

function LoadHotModules() {
	//console.log("Reloading hot modules...");
	//require("./Main_Hot.js");
	require("./Main_Hot");
}

//setTimeout(()=>LoadHotModules());
LoadHotModules();